<template>
    <section>
        <r-e-dialog title="转移押金账单" :visible.sync="dialogVisible" show-footer top="10vh" width="550px"
                    @click-submit="clickSubmit" @click-cancel="clickCancel" @close="clickCancel">
            <el-form ref="formPublish" label-width="100px" size="small" :model="formPublish" :rules="rules">
                <div class="flex">
                    <el-form-item label="当前合同">
                        <el-input v-model="contractNum" style="width: 365px;" disabled/>
                    </el-form-item>
                </div>
                <div class="flex">
                    <el-form-item label="转移合同" prop="contractUuid">
                        <el-select v-model="formPublish.contractUuid" style="width: 365px;" placeholder="请选择转移合同">
                            <el-option v-for="(item,index) in contractList" :key="index" :label="item.contractNum"
                                       :value="item.uuid"/>
                        </el-select>
                    </el-form-item>
                </div>
            </el-form>
        </r-e-dialog>
    </section>
</template>

<script>
import {getContractListByUserAndHouse, updateDepositToContract} from "@/api/bill";
import {MessageWarning,MessageSuccess} from "@custom/message";

export default {
    name: "layer-transfer-deposit-bill",
    data() {
        return {
            dialogVisible: false,
            formPublish: {
                billUuid: null,
                contractUuid: null
            },
            rules: {
                contractUuid: [{required: true, message: '请选择转移合同', trigger: 'change'}],
            },
            loadingOptions: {
                lock: true,
                text: "Loading...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            },
            contractNum: null,
            contractList: [],
        };
    },
    components: {},
    methods: {
        openDialog(data) {
            const {leasorUuid, apartmentUuid, contract: {uuid: contractUuid, contractNum},uuid} = data;
            let that = this;
            const loadingOptions = that.loadingOptions;
            const loading = that.$loading({...loadingOptions});
            getContractListByUserAndHouse({leasorUuid, apartmentUuid, contractUuid}).then(res => {
                const {list} = res;
                if (list.length > 0) {
                    that.formPublish.billUuid = uuid;
                    that.contractNum = contractNum;
                    that.contractList = list;
                    that.dialogVisible = true;
                } else MessageWarning("当前房源没有其他合同,无法转移押金账单", 1000);
            }).finally(() => loading.close());
        },
        clickSubmit() {
            let that = this;
            this.$refs["formPublish"].validate((valid) => {
                if (valid) {
                    const {billUuid,contractUuid} = that.formPublish;
                    const loadingOptions = that.loadingOptions;
                    const loading = that.$loading({...loadingOptions});
                    updateDepositToContract({billUuid,contractUuid}).then(res => {
                        MessageSuccess('转移成功');
                        that.clickCancel();
                    }).finally(() => loading.close());
                }
            });
        },
        async clickCancel() {
            this.formPublish = {billUuid: null, contractUuid: null};
            await this.$emit('clickCancel');
            this.dialogVisible = false;
        },
    },
    created() {
    },
}
</script>

<style scoped>

</style>